module.exports = __webpack_public_path__ + "static/media/memento_feature_1.1a962db5.png";